import(/* webpackMode: "eager", webpackExports: ["BoardLoading"] */ "/vercel/path0/app/board/board-loading.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/board/board.css");
